export default __webpack_public_path__ + "static/media/scholarship-icon-form.357de6f5.svg";